module.exports = __webpack_public_path__ + "img/d1.21db25e6.png";